<template>
	<div class="numbers highlighted-content">
		<!-- <div class="calc_method" v-if="isHomework" :style="calcMethod === 'oral' ? 'left: calc(50% - 44px)' : ''"
			:class="{ abacus: calcMethod !== 'oral', small: isSmallFont }">

			<img src="../../../assets/oral_counting.png" class="oral-img" v-if="calcMethod === 'oral'" />

			<Abacus v-else />
		</div> -->



		<span :class="{ small: isSmallFont }" class="number">{{ number }}</span>
	</div>
</template>

<script>
export default {
	name: 'numbers',

	props: {
		isSmallFont: Boolean,
		isHomework: Boolean,
		number: {
			type: [Number, String],
			required: true,
		},
		calcMethod: [Object, String],
	},

	computed: {
		isCustomBgEnabled() {
			return !!this.$store.getters.primaryBackground
		},
	},
}
</script>

<style scoped lang="scss">
// @import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:700');

.numbers {
	min-width: 1000px;
	// width: fit-content;
	margin: auto;
	padding: 12px;

	&.highlighted-content {
		background: #fff;
		border-radius: 12px;
		border: 2px solid red;
		color: #e4467b;
	}

	@media (max-width: 1000px) {
		min-width: 300px;
	}
}



.number {
	color: #e4467b;
	line-height: 26rem;
	min-height: 26rem;
	display: block;
	font-weight: 700;
	font-size: 26rem;
	font-family: 'Roboto Condensed', sans-serif;
}

.number.small {
	font-size: 20rem;
}

@media (max-width: 767px) {
	.number {
		font-size: 12rem;
		line-height: 12rem;
		min-height: 12rem;
	}
}

@media (max-width: 480px) {
	.number {
		min-height: 6rem;
		line-height: 6rem;
		font-size: 6rem;
	}
}
</style>
